import {Credentials} from '@mintdata-wsp/common/state/DataState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {DataLine} from '@mintdata-wsp/wsp/ui/components/dataline/DataLine';
import {MenuItem} from '@mintdata-wsp/wsp/ui/components/menus/MenuItem';
import {EditCredentials} from '@mintdata-wsp/wsp/ui/views/workspace/settings/organization/authentication/EditCredentials';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./CredentialsCard.less');
const cx = classnames.bind(styles);

export interface CredentialsCardProps
{
    credentials:Credentials;
    isNew:boolean;
}

@observer
export class CredentialsCard extends React.Component<CredentialsCardProps, any>
{
    private _menuItems:MenuItem[] = this._computeMenu();

    @observable
    private _isEdit:boolean = false;

    render()
    {
        const {credentials, isNew: isNewLine} = this.props;

        const {name} = credentials;

        return (
            <DataLine
                menuItems={this._isEdit ? null : this._menuItems}
                isNewLine={isNewLine}
                className={cx('credentialsCard')}
            >
                {
                    !this._isEdit &&
                    <div className={cx('name')}>
                        {name}
                    </div>
                }
                {
                    this._isEdit &&
                    <EditCredentials
                        isReadOnly={true}
                        className={cx('editMode')}
                        credentials={credentials}
                        buttonTitle={'Save'}
                        onClose={this._closeEdit}
                        onChange={this._onChangeCredentials}
                    />
                }
            </DataLine>
        );
    }

    @bind
    private _computeMenu():MenuItem[]
    {
        return [
            MenuItem.simple('edit', 'Edit', this._menuItemEditCredentials),
            MenuItem.separator(),
            MenuItem.simple('delete', 'Delete', this._menuItemDeleteCredentials),
        ];
    }

    @action.bound
    private _menuItemEditCredentials()
    {
        this._isEdit = true;
    }

    @action.bound
    private _closeEdit()
    {
        this._isEdit = false;
    }

    @bind
    private _onChangeCredentials(newCredentials:Credentials)
    {
        const {credentials} = this.props;

        controllers.data.credentials.updateCredentials(credentials, newCredentials)
            .then(action(() =>
            {
                this._isEdit = false;
            }))
            .catch(() =>
            {
            });
    }

    @bind
    private _menuItemDeleteCredentials()
    {
        const {credentials} = this.props;

        controllers.ui.dialogs.showDangerConfirm(
            `Remove Credentials "${credentials.name}"?`,
            'Credentials will be deleted. This operation cannot be undone.',
            () =>
            {
                controllers.data.credentials.deleteCredentials(credentials)
                    .then(() =>
                    {
                        controllers.ui.dialogs.hideConfirmDialog();
                    })
                    .catch(() =>
                    {
                    });
            },
            ['Cancel', 'REMOVE']
        );
    }
}





